import { useSelector } from 'react-redux'
import { LabeledText } from 'src/components/UI'
import { getJob } from 'src/ducks/selectors'
import { formatTimestampUTC } from 'src/helpers'
import { useIsLgScreen, useIsXlScreen } from 'src/hooks'
import { ContentBox, Divider, TabBox } from '../../Templates'

const Approval = () => {
  const job = useSelector(getJob())
  const homeOwner = job?.properties?.contacts?.find(contact => contact?.role === 'HOMEOWNER')
  const payer = job?.properties?.contacts?.find(contact => contact?.isPayer)
  const [xlScreen] = useIsXlScreen()
  const [lgScreen] = useIsLgScreen()

  return (
    <TabBox>
      <ContentBox gridTemplateColumns={xlScreen || lgScreen ? '1fr 1fr' : '1fr'}>
        <LabeledText labelValue={homeOwner?.fullName || ''} textValue={homeOwner ? '(Homeowner)' : ''} />
        <LabeledText labelValue={payer?.fullName || ''} textValue={payer ? '(Payer)' : ''} />
        <LabeledText labelValue='' textValue={homeOwner?.email || ''} />
        <LabeledText labelValue='' textValue={payer?.email || ''} />
        <LabeledText labelValue='' textValue={homeOwner?.phone} />
        <LabeledText labelValue='' textValue={payer?.phone} />
      </ContentBox>
      <Divider />
      <ContentBox>
        <LabeledText labelValue='Closing Date:' textValue={formatTimestampUTC(job?.properties?.closingDate, 'MM/DD/YYYY')} />
        <LabeledText labelValue='Preferred Start Date:' textValue={formatTimestampUTC(job?.properties?.preferredStartDate, 'MM/DD/YYYY')} />
        <LabeledText labelValue='Preferred Completion Date:' textValue={formatTimestampUTC(job?.properties?.preferredCompletedOn, 'MM/DD/YYYY')} />
      </ContentBox>
      <Divider />
      <ContentBox>
        <LabeledText labelValue='Approval Signature:' textValue={job?.properties.contacts.find(c => c.isInitialAuthorizer)?.firstName + ' ' + job?.properties.contacts.find(c => c.isInitialAuthorizer)?.lastName} />
        <LabeledText labelValue='Access Code:' textValue={job?.properties?.accessDetails} />
        <LabeledText labelValue='Notes:' textValue={job?.properties?.clientNotes} />
      </ContentBox>
    </TabBox>
  )
}

export default Approval
